// QuestLog — popover listing vsj.quests rows (name from infos, progress,
// Track, Claim glowing when done). Opened by clicking the quest bar.

import { clear, el, kbtn } from '../kit';
import * as ui from '../ui';
import * as vsj from '../vsj';

let pop: HTMLElement | null = null;
let content: HTMLElement;

function ensure(): void {
  if (pop) return;
  content = el('div', { style: 'display:flex;flex-direction:column;gap:6px' });
  pop = el(
    'div',
    {
      class: 'k-panel',
      style:
        'position:fixed;z-index:70;min-width:360px;max-width:440px;padding:10px;display:none;' +
        'background:var(--bg-modal);border-color:var(--border-light);max-height:60vh;overflow-y:auto',
    },
    content,
  );
  document.body.append(pop);
  document.addEventListener('pointerdown', (e) => {
    if (pop && pop.style.display !== 'none' && !pop.contains(e.target as Node)) hide();
  });
  vsj.onChange((changed) => {
    if (pop && pop.style.display !== 'none' &&
        (changed.has('quests') || changed.has('infos') || changed.has('quest_bar') || changed.has('*')))
      fill();
  });
}

function fill(): void {
  clear(content);
  content.append(el('div', { class: 'k-title', text: 'Quests' }));
  const quests = vsj.at('quests') ?? {};
  const tracked = String(vsj.at('quest_bar.tracked') ?? '');
  const ids = Object.keys(quests).sort();
  if (!ids.length) {
    content.append(el('div', { class: 'k-small k-dim', text: 'Nothing in hand.' }));
    return;
  }
  for (const qid of ids) {
    const q = quests[qid];
    if (!q || typeof q !== 'object') continue;
    const isTracked = qid === tracked;
    const name = el('span', {
      class: 'c-link',
      style: 'flex:1;color:var(--text)',
      text: vsj.infoName(qid),
    });
    name.addEventListener('click', () => {
      ui.select(qid);
      hide();
    });
    const row = el(
      'div',
      {
        class: 'k-panel raised',
        style:
          'display:flex;gap:8px;align-items:center;padding:6px 8px' +
          (isTracked ? ';border-color:var(--border-active)' : ''),
      },
      name,
      el('span', { class: 'k-small k-dim', text: String(q.progress ?? '') }),
    );
    if (q.track) row.append(kbtn(q.track, { label: 'Track', compact: true }));
    else if (isTracked) row.append(el('span', { class: 'k-chip', style: 'border-color:var(--border-active)', text: 'tracked' }));
    if (q.claim) row.append(kbtn(q.claim, { label: 'Claim', compact: true, cls: 'claim-pulse', clickSound: 'claim' }));
    content.append(row);
  }
}

export function openQuestLog(anchor: HTMLElement): void {
  ensure();
  fill();
  const r = anchor.getBoundingClientRect();
  pop!.style.display = 'block';
  pop!.style.left = `${Math.min(r.left, innerWidth - 420)}px`;
  pop!.style.top = `${r.bottom + 4}px`;
}

function hide(): void {
  if (pop) pop.style.display = 'none';
}
